import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconContourSizeS from './IconContour_size_s';

const props: CreateIconArguments = {
  l: IconContourSizeS,
  m: IconContourSizeS,
  s: IconContourSizeS,
  xs: IconContourSizeS,
  name: 'IconContour',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
